<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp; Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    @change="searching"
                    format="DD-MMM-YYYY"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    @change="searching"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Department</label>
                  <a-select
                    placeholder="Select Department"
                    v-model="department"
                    @change="searching"
                    class="width-full"
                    initialValue=""
                    allowClear
                  >
                    <a-select-option
                      v-for="item in departmentList"
                      :key="item.id_dept"
                      :value="item.id_dept"
                      >{{ item.nama_dept }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        title="Sales Notification List"
        createLink="createSalesNotification"
        manifestLink="manifestSalesNotification"
        editLink="editSalesNotification"
        :dataList="dataListOutput"
        :estimasi="true"
        :isTransactional="true"
        :disabledCreateEditLink="bidangAccountManager"
        :allowcancel="true"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import Axios from "axios";
import moment from "moment";
import Status from "@/components/Status.vue";
import Rating from "@/components/Rating.vue";

export default {
  name: "SalesNotification",
  components: {
    Status,
    Rating,
  },
  data() {
    return {
      loading: true,
      salesNotifList: [],
      storeList: [],
      search: "",
      searchDate: null,
      status: undefined,
      department: undefined,
      departmentList: [],
      kategori: "",
      pagination: {
        pageSize: 5,
        size: "small",
      },
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getSalesType",
      "getStatus",
      "getDefaultDateFormat",
    ]),
    dataListOutput() {
      let output = [];

      this.salesNotifList.forEach((data) => {
        output.push({
          title: data.no_salesnotif,
          subdesc: [
            moment(data.tanggal).format(this.getDefaultDateFormat) +
              " - " +
              data.tlc,
            //data.project_nm ? data.project_nm : "-",
            data.deskripsi ? data.deskripsi : "-",
          ],
          status: data.status=='Revised' ? (this.getAuth.username==data.tlc ? data.status : null) : null,
          cancelStatus: data.cancel_sts
            ? data.cancel_sts == 1
              ? "Canceled"
              : data.cancel_sts == 2
              ? "Unusual"
              : null
            : null,
          id: data.id_salesnotif,
          timeline: JSON.parse(data.status_app),
          islistPPrevised: false,
          id_dept: data.id_dept,
        });
      });

      return output;
    },
    searching() {
      let filteredDataBySearch = [];
      this.salesNotifList = this.storeList;

      if (this.search) {
        this.salesNotifList = this.salesNotifList.filter(
          (obj) =>
            obj.no_salesnotif
              .concat(obj.project_nm)
              .concat(obj.deskripsi ? obj.deskripsi : "-")
              .concat(moment(obj.tanggal).format(this.getDefaultDateFormat))
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.kategori) {
        this.salesNotifList = this.salesNotifList.filter(
          (obj) =>
            obj.kategori &&
            obj.kategori.toLowerCase().indexOf(this.kategori.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        this.salesNotifList = this.salesNotifList.filter(
          (obj) =>
            obj.status &&
            obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }

      if (this.department) {
        this.salesNotifList = this.salesNotifList.filter(
          (obj) =>
            obj.id_dept &&
            obj.id_dept.toLowerCase().indexOf(this.department.toLowerCase()) >= 0
        );
      }

      if (this.searchDate) {
        let searchDate = moment(this.searchDate).format("YYYY-MM-DD");
        this.salesNotifList = this.salesNotifList.filter(
          (obj) => obj.tanggal === searchDate
        );
      }

      if (!this.kategori && !this.search && !this.status && !this.department && !this.searchDate) {
        this.salesNotifList = this.storeList;
      }
    },
    bidangAccountManager() {
      let returnVal = true;
      this.getAuth.nama_bidang.forEach((data) => {
        if (data === "Account Manager") {
          returnVal = false;
          return;
        }
      });
      this.getAuth.divisi.forEach((data) => {
        if (data === "Business Development" || data === "Marketing") {
          returnVal = false;
          return;
        }
      });
      return returnVal;
    },
  },
  methods: {
    moment,
    fetchSalesNotification() {
      Axios({
        method: "get",
        url: this.$serviceUrl + "sales_notification",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.salesNotifList = response.data.data;
          this.storeList = response.data.data;
          this.departmentList = response.data.dept;
          this.loading = false;
        })
        .catch((err) => {
          if (!error.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    canceltrans(item) {
      Axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "salesnotif",
          id_manifest: item.id,
          code_trans: item.title,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          //this.fetchData();
          this.$router.go();
          //this.searching;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
  mounted() {
    this.fetchSalesNotification();
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
  },
};
</script>

<style></style>
